export default __webpack_public_path__ + "static/media/modalCheckboxActive.bc136ac1.svg";